import { useSearchParams } from 'react-router-dom';

import { COMPONENT_TASKS_TABLE_PAGE_SIZE } from '../shared/constants/tasks.constant';
import { parseString } from '../shared/helpers/url-parameter-parser';
import { GetTasksParams } from './api/request-pcf';

const DEFAULT_SORT = 'lastUpdated-desc';

type ComponentTasksTableQueryState = {
  skip: number;
  size: number;
  filters: Partial<GetTasksParams>;
  sort: string | undefined;
  setParams: (params: Record<string, string | number | string[] | undefined>) => void;
};

export const useComponentTasksTableQueryParams = (): ComponentTasksTableQueryState => {
  const [sp, setSp] = useSearchParams();

  // Pagination
  const skip =
    (Number(sp.get('page') ?? 1) - 1) * Number(sp.get('size') ?? COMPONENT_TASKS_TABLE_PAGE_SIZE);
  const size = Number(sp.get('size') ?? COMPONENT_TASKS_TABLE_PAGE_SIZE);

  // Sorting
  const sort = sp.get('sort') ?? DEFAULT_SORT;

  // Filters
  const filters: Partial<GetTasksParams> = {
    status: parseString(sp.get('status')),
    search: parseString(sp.get('search')),
  };

  // Function to set multiple URL params at once
  const setParams = (params: Record<string, string | number | string[] | undefined>): void => {
    const next = new URLSearchParams(sp);

    Object.entries(params).forEach(([key, value]) => {
      if (value === undefined || (Array.isArray(value) && value.length === 0) || value === '') {
        next.delete(key);

        return;
      }

      if (Array.isArray(value)) {
        next.set(key, value.join(','));

        return;
      }

      next.set(key, String(value));
    });

    setSp(next, { replace: true });
  };

  return {
    skip,
    size,
    sort,
    filters,
    setParams,
  };
};
